import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {transactionsSlipList_template} from "../components/templates/transactionsSlipList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {downloadCSV} from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {vnApp_emaki} from "../components/vnApp_emaki";
import {valnetAccess_isOfRole} from "../../vendor/valnet/valnet_access/src/js/helper";
import { resultsInfo_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;
declare var page: any;

export class transactions_slip extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: transactionsSlipList_template;
    protected idCurrency: Number;


    protected getModuleName(){

        return "transactions_slip";
    }

    buildContent() : Array<Element>{

        let vnApp = this.getVnAppZone().app;
        this.elementsList = new transactionsSlipList_template("list", this.viewModel, this);
        let zoneHeader = vnApp.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Payment Slips List");

        if(valnetAccess_isOfRole(vnApp, vnApp_emaki.ROLE_NAME_ADMINISTRATOR)
            || valnetAccess_isOfRole(vnApp, vnApp_emaki.ROLE_NAME_WEBSITE_ADMINISTRATOR)
            || valnetAccess_isOfRole(vnApp, vnApp_emaki.ROLE_NAME_ACCOUNTANT)){
            this.elementsList.setIsShowExportVisible(true);
        }

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getfilterReference();
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected viewSlipDetail(data){
        this.saveViewModule(this.elementsList.getViewModelForRequest());
        page('/payment/documents/slip/'+ data.idUser + '?datePaid=' + data.paymentDate);
    }

    protected filterSimpleOnChange(){
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected slipsListReorder(){
        this.filterList();
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }


        let subViewModel = this.elementsList.getViewModelForRequest();
        let usrReq_url: string = '/api/transactions/getbyuser';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                const {totalPage, totalCount} = responseParsed.data.data;
                const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100
                if( req.request.status == 200 ){
                    obj.elementsList.validationsList.clearMessages();
                    obj.elementsList.setResultInfo(totalCount, totalPage, execTime);

                    obj.updateList(responseParsed);

                } else if( req.request.status == 423 ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/home');
                }
                else{
                    obj.onUpdateError(responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    protected getfilterReference() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string;

        usrReq_url = '/api/transactions/references';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetfilterReferenceRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected filterDropdownOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected onGetfilterReferenceRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.elementsList.validationsList.clearMessages();
                    obj.updateReferenceList(responseParsed.data);
                    obj.filterList()
                } else if (req.request.status == "423") {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    let url: string;
                    if (obj.getVnAppZone().app.params.idBrand) {
                        url = '/' + obj.getVnAppZone().app.params.idBrand + '/home';
                    } else {
                        url = '/';
                    }
                    page.redirect(url);
                } else {

                    obj.listTemplate.onUpdateError(responseParsed);
                }

            }
        }
    }

    protected updateReferenceList(responseParsed: any) {

        this.elementsList.setTransactionSystemOptions(responseParsed.transactionSystems);
        this.elementsList.setEntryTypeOptions(responseParsed.entryTypes);
        this.elementsList.setCurrencyOptions(responseParsed.currencies);
        responseParsed.accounts.push({id:null, name:'No Account'});
        this.elementsList.setAccounts(responseParsed.accounts);
        this.elementsList.setCompanyOptions(responseParsed.companies);

        this.elementsList.setIsShowExportVisible(responseParsed.permissions.trx_slips_list.read);
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed){

        let huit_neuf_this = this.elementsList;
        let _this = this;

        let slipsToSet = [];
        for (let item of responseParsed.data.data.data) {

            slipsToSet.push(item);
        }
        let payments = [];

        if(responseParsed.data.payments) {
            for (let p of responseParsed.data.payments) {
                payments.push({
                    id: p.id,
                    datePaid: p.datePaid.slice(0, 10)
                })
            }
        }
        this.elementsList.setSlips(slipsToSet);
        this.elementsList.setPaymentDateOptions(payments);
        this.viewModel.list.pagination.pageNumber(responseParsed.data.data.currentPage);
        this.viewModel.list.pagination.itemCount(responseParsed.data.data.totalCount);
        // this.viewModel.list.filterUser.users(responseParsed.users);
    }

    protected filterMultipleSelectorOnChange(){

        this.filterList();
    }

    protected onUpdateError(responseParsed: any): void {
        const defaultMsg = "An error occurred while processing your request. Please try again later.";
        const message = (responseParsed && responseParsed.message) || defaultMsg;

        this.elementsList.validationsList.setSingleMessage({
            field: "error",
            label: "Error",
            message
        });

        window.scrollTo(0, 0);
    }


    protected getUsersSuggestion(keyword) {

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/search/user/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.users) {
                        obj.elementsList.setUsers(responseParsed.data.users);
                    }
                    obj.elementsList.validationsList.clearMessages();
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.elementsList.onUpdateError(responseParsed);
                }

                // LOADING : ends
                obj.elementsList.deactivateLoading();
            }
        }

    }

    public exportToCSV(data:any){

        let Data = [];
        let total = 0;
        let amount = 0;
        data.data.sort( this.compare );
        for (let row of data.data){
                amount = Number(row["amount"].replace('$','').replace(',',''));
                if(amount < 0) {
                    amount = 0;
                }
                total += Number(row["amount"].replace('$','').replace(',',''));
                Data.push({
                    "User ID": row["idUser"],
                    "User": row["userFullName"],
                    "User Legal Name": row["userFullLegalName"],
                    "Country": row["country"],
                    "State": row["state"],
                    "Payment Method": row["paymentMethod"],
                    "Paypal/Payoneer Account": (row["paymentMethod"].toLowerCase() == "paypal" || row["paymentMethod"].toLowerCase() == "payoneer" ? row["paymentEmail"] : ""),
                    "Sort Code and Bank Account": row["paymentMethod"].toLowerCase() == "bank transfer" && row["accountInfo"] ? String(row["accountInfo"].match(/[0-9]+/g).join("")) : "",
                    "Bank Name": row["paymentMethod"].toLowerCase() == "bank transfer" && row["bankName"] ? row["bankName"] : "",
                    "Bank Address": row["paymentMethod"].toLowerCase() == "bank transfer" && row["bankAddress"] ? row["bankAddress"] : "",
                    "Bank Account Number": row["paymentMethod"].toLowerCase() == "bank transfer" && row["bankAccountNumber"] ? String(row["bankAccountNumber"]) : "",
                    "Bank Number":  row["paymentMethod"].toLowerCase() == "bank transfer" && row["bankNumber"] ? String(row["bankNumber"]): "",
                    "Bank Transit Number": row["paymentMethod"].toLowerCase() == "bank transfer" && row["bankTransit"] ? String(row["bankTransit"]) : "",
                    "Unique ID": row['idUser'] + '-' + row['paymentDate'].replace("-", "").replace("-", "") ,
                    "Description" : "Payment for work completed",
                    "Payment Date": row["paymentDate"],
                    "Currency": row["currency"],
                    "Total Paid": amount
                });
        }
        Data.push({
            "User ID": "Total",
            "User": "",
            "User Legal Name": "",
            "Country": "",
            "State": "",
            "Payment Method": "",
            "Paypal/Payoneer Account": "",
            "Sort Code and Bank Account": "",
            "Bank Name": "",
            "Bank Address": "",
            "Bank Account Number": "",
            "Bank Number": "",
            "Bank Transit Number": "",
            "Unique ID": "",
            "Description": "",
            "Payment Date": "",
            "Currency": data.data[0]['currency'],
            "Total Paid":data.data[0]['currency'] + ' ' + total.toLocaleString(undefined, {minimumFractionDigits: 2})
        });

        let csvData = Data;
        downloadCSV({filename: data.data[0]['currency'] + "-SummaryReport.csv", data: csvData});
    }

    public exportBankTransfer(data:any){

        let Data = [];
        let total = 0;
        let amount = 0;
        data.data.sort( this.compare );
        for (let row of data.data){
            if(row["paymentMethod"].toLowerCase() != "bank transfer"){
                continue;
            }
            amount = Number(row["amount"].replace('$','').replace(',',''));
            if(amount < 0) {
                amount = 0;
            }
            total += Number(row["amount"].replace('$','').replace(',',''));
            Data.push({
                " ": amount,
                "  ": row["paymentMethod"].toLowerCase() == "bank transfer" && row["accountInfo"] ? String(row["accountInfo"].match(/[0-9]+/g).join("")) : "",
                "   ": row["userFullLegalName"],
                "    ": row['idUser'] + '-' + row['paymentDate'].replace("-", "").replace("-", "") ,
            });
        }

        let csvData = Data;
        downloadCSV({filename: data.data[0]['currency'] + "-bankTransferExport.csv", data: csvData});
    }

    public exportCADToCSV(data:any){

        let CADData = [];
        let totalCAD = 0;
        let amount = 0;
        data.data.sort( this.compare );
        for (let row of data.data){
            if(row["currency"] == "CAD"){
                amount = Number(row["amount"].replace('$','').replace(',',''));
                if(amount < 0) {
                    amount = 0;
                }
                totalCAD += Number(row["amount"].replace('$','').replace(',',''));
                CADData.push({
                    "User ID": row["idUser"],
                    "User": row["userFullName"],
                    "User Legal Name": row["userFullLegalName"],
                    "Payment Method": row["paymentMethod"],
                    "PayPal ID": row["paymentEmail"],
                    "Unique ID": row['idUser'] + '-' + row['paymentDate'].replace("-", "").replace("-", "") ,
                    "Description" : "Payment for work completed",
                    "Payment Date": row["paymentDate"],
                    "Currency": row["currency"],
                    "Total Paid": amount
                });
            }
        }
        CADData.push({
            "User ID": "Total",
            "User": "",
            "User Legal Name": "",
            "Payment Method": "",
            "Payment Method ID": "",
            "Unique ID": "",
            "Description": "",
            "Payment Date": "",
            "Currency": "CAD",
            "Total Paid":'$' + totalCAD.toLocaleString(undefined, {minimumFractionDigits: 2})
        });

        let csvData = CADData;
        downloadCSV({filename: "CAD-SummaryReport.csv", data: csvData});
    }


    public exportUSDToCSV(data:any, idMethod: Number){

        let USDData = [];
        let totalUSD = 0;
        let amount = 0;
        let paymentMethod = '';
        data.data.sort( this.compare );
        for (let row of data.data){
            if(row["currency"] == "USD" && idMethod == row['idMethod']){
                paymentMethod = row["paymentMethod"];
                amount = Number(row["amount"].replace('$','').replace(',',''));
                if(amount < 0) {
                    amount = 0;
                }
                totalUSD += Number(row["amount"].replace('$','').replace(',',''));
                USDData.push({
                    "User ID": row["idUser"],
                    "User": row["userFullName"],
                    "User Legal Name": row["userFullLegalName"],
                    "Payment Method": row["paymentMethod"],
                    "Payment Method ID": row["paymentEmail"],
                    "Unique ID": row['idUser'] + '-' + row['paymentDate'].replace("-", "").replace("-", "") ,
                    "Description" : "Payment for work completed",
                    "Payment Date": row["paymentDate"],
                    "Currency": row["currency"],
                    "Total Paid":amount
                });
            }
        }

        USDData.push({
            "User ID": "",
            "User": "Total",
            "User Legal Name": "",
            "Payment Method": "",
            "Payment Method ID": "",
            "Unique ID": "" ,
            "Description": "",
            "Payment Date": "",
            "Currency": "USD",
            "Total Paid":'$' + totalUSD.toLocaleString(undefined, {minimumFractionDigits: 2})
        });
        let csvData = USDData;
        downloadCSV({filename: "USD-SummaryReport.csv", data: csvData});
    }

    protected compare( a, b ) {
        if ( a["paymentMethod"] < b["paymentMethod"] ){
            return -1;
        }
        if ( a["paymentMethod"] > b["paymentMethod"] ){
            return 1;
        }
        return 0;
    }

    protected getExportData(){

        // LOADING : starts
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.elementsList.getViewModelForRequest();
        let subViewModelClone = Object.assign({}, subViewModel);
        subViewModelClone.pagination.pageNumber(1)
        subViewModelClone.pagination.itemPerPage = 100000;

        let usrReq_url: string = '/api/transactions/getbyuser';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModelClone)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetExportDataReturn;
        this.XHRHdl.execute();

    }

    protected onGetExportDataReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ){
                    if(obj.elementsList.getTemplateViewModel().exportType() == 'bank transfer'){
                        obj.exportBankTransfer(responseParsed.data.data);
                    } else {
                        console.log('hrer')
                        obj.exportToCSV(responseParsed.data.data);
                    }
                    obj.elementsList.getTemplateViewModel().exportType('')
                } else if( req.request.status == 423 ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/home');
                }
                else{
                    obj.onUpdateError(responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    protected generatePaymentXML(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        const subViewModel = this.elementsList.getViewModelForRequest();
        const subViewModelClone = Object.assign({}, subViewModel);
        subViewModelClone.pagination.pageNumber(1)
        subViewModelClone.pagination.itemPerPage = 100000;

        const usrReq_url: string = '/api/transactions/payments/generate-xml';
        const usrReq_params: string[][] = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModelClone)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onGeneratePaymentXMLReturn;
        this.XHRHdl.execute();

    }

    protected onGeneratePaymentXMLReturn(req, obj) {

        return function () {
            if (req.request.readyState === 4 && req.request.status === 200) {
                obj.triggerXMLDownload(req.request.response);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            } else if (req.request.status === 423) {
                const responseParsed = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                obj.getVnAppZone().showNotificationToModule();
                page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/home');
            } else {
                const responseParsed = JSON.parse(req.request.response);
                obj.onUpdateError(responseParsed);
            }
        };
    }

    private triggerXMLDownload(response: string | Blob) {
        const handleContent = (text: string) => {
            const trimmed = text.trim();
            const blob = new Blob([trimmed], { type: 'application/xml' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');

            const subViewModel = this.elementsList.getViewModelForRequest();
            const vm = ko.toJS(subViewModel);
            const paymentDate = vm.filters.idPayment;
            const date = new Date(paymentDate);
            const year = date.getFullYear().toString();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const yearMonthDay = year + (month < 10 ? '0' + month : month) + (day < 10 ? '0' + day : day);
            const filename = `pain.001-${yearMonthDay}.xml`;

            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        };

        if (typeof response === 'string') {
            handleContent(response);
        } else {
            const reader = new FileReader();
            reader.onload = () => {
                const text = reader.result as string;
                handleContent(text);
            };
            reader.readAsText(response);
        }
    }


}



// WEBPACK FOOTER //
// ./js/modules/transactions_slip.ts